<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Header -->
							<div class="page_header">Training Record List</div>
							<!-- Header -->
							<div class="page_main">
								<div class="training-config-page">
									<!-- Search Area -->
									<el-form ref="query" :model="query" label-position="top" class="search-form">
										<div class="form-grid">
											<!-- Left -->
											<div class="form-col">
												<el-form-item label="Name">
													<el-input v-model="query.title" placeholder="Please enter" clearable />
												</el-form-item>
											</div>
											<!-- Right -->
											<div class="form-col">
												<el-form-item label="Description">
													<el-input v-model="query.description" placeholder="Please enter" clearable />
												</el-form-item>
											</div>
										</div>
										<div class="form-btns">
											<el-button type="primary" @click="getList">Search</el-button>
										</div>
									</el-form>
				
									<!-- Table -->
									<el-table v-loading="tableLoading" :data="tableData" border style="width: 100%">
										<el-table-column label="Actions" width="90" align="center">
											<template slot-scope="scope">
												<el-button type="primary" size="mini" @click="handleEdit(scope.row)">
													Edit
												</el-button>
											</template>
										</el-table-column>
				
										<el-table-column prop="title" label="Name" />
				
										<el-table-column prop="description" label="Description" />
				
										<el-table-column label="Actions" width="380" align="center">
											<template slot-scope="scope">
												<el-button type="primary" size="mini" @click="handleManage(scope.row)">
													Manage Training
												</el-button>
				
												<el-button type="primary" size="mini" @click="handleInfo(scope.row)">
													Details
												</el-button>
				
												<el-button type="danger" size="mini" @click="handleDel(scope.row)">
													Delete
												</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import {
		trainRecordList,
		trainRecordDel,
	} from "@/api/trainManage/configTrain/trainRecord/index";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				mark: "",
				tableLoading: false,
				query: {
					title: "",
					description: "",
					time1: "",
					time2: "",
					page: 1,
					page_size: 9999999,
				},
				tableData: [],
			};
		},
		created() {
			let that = this;
			that.mark = that.$route.query.flag;
		},
		mounted() {
			let that = this;
			that.isLoading = false;
			that.getTableData();
		},
		watch: {
			//
		},
		methods: {
			getList() {
				this.getTableData();
			},
			//获取表格数据
			getTableData() {
				let that = this;
				that.tableLoading = true;
				trainRecordList(that.query).then((res) => {
					that.tableLoading = false;
					if (res.code == 200) {
						that.tableData = res.data.data;
					}
				});
			},
			handleManage(row) {
				let that = this;
				that.$router.push({
					path: "/TrainControl/manage-train",
					query: {
						type: "demand",
						recordId: row.id,
						recordName: encodeURIComponent(row.title),
					},
				});
			},
			handleInfo(row) {
				let that = this;
				const routeData = that.$router.resolve({
					path: '/TrainControl/archival-detail',
					query: {
						id: row.id
					}
				});
				window.open(routeData.href, "_blank");
			},
			handleEdit(row) {
				let that = this;
				that.$router.push({
					path: "record-add-edit",
					query: {
						oid: row.id
					}
				});
			},
			handleDel(row) {
				let that = this;
				that
					.$confirm("Are you sure you want to delete this training file?", "Confirmation", {
						type: "warning",
					})
					.then(() => {
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						trainRecordDel({
							id: row.id
						}).then((res) => {
							if (res.code == 200) {
								that.$toast.clear();
								that.$message.success("Operation successful");
								setTimeout(() => {
									that.getTableData();
								}, 800);
							}
						});
					})
					.catch(() => {});
			},
			//跳转页面
			goUrl(url) {
				let that = this;
				that.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.training-config-page {
		padding: 20px;
	}

	.search-form {
		margin-bottom: 20px;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 24px;
		align-items: start;
	}

	.form-grid .el-form-item {
		margin-bottom: 0;
	}

	.full-width {
		width: 100%;
	}

	.input-btn-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.input-btn-group .el-input {
		flex: 1;
	}

	.form-btns {
		text-align: center;
		margin-top: 30px;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}
</style>